import enums from '@/enums'
import { ConfirmModalConfig, NodePool } from '@/types'
import { APICluster } from '@/typesAPI'

type State = {
  isVisible: {[key:string]:boolean},
  clusterSelected:APICluster | null,
  nodePools: NodePool[],
  draftNodePoolTypology?: NodePool,
  confirmModalConfig?: ConfirmModalConfig,
}

const state: State = {
  isVisible: {},
  clusterSelected: null,
  nodePools: []
}


const getters = {
  getConfirmModalConfig: (state:State) => {
    return state.confirmModalConfig 
  },
  getVisibilitConfirmModal: (state:State) => {
    return !!state.isVisible['confirmModal'] 
  },
  getVisibilityCluster: (state:State) => {
    return !!state.isVisible[enums.ModalsName.Cluster] 
  },
  getClusterSelected: (state:State) => {
    return state.clusterSelected
  },
  getNodePools: (state:State) => {
    return state.nodePools
  },
}

const mutations = {
  SET_VISIBILITY: (state:State, payload:{modal:any, newState:boolean}) => {
    state.isVisible[payload.modal] = payload.newState
  },
  ASK_CONFIRMATION: (state:State, payload:ConfirmModalConfig) => {
    state.isVisible['confirmModal'] = true
    state.confirmModalConfig = payload
  },
  SET_CLUSTER_SELECTED: (state:State,newCluster:APICluster | null) => {
    state.clusterSelected = newCluster
  },
  SET_NODE_POOLS: (state:State,nodePools:NodePool[]) => {
    state.nodePools = nodePools
  },
  HIDE_ALL: (state:State) => {
    state.isVisible = {}
  },

}

const actions = {
  askConfirmation: (context:any,payload:ConfirmModalConfig) => {
    context.commit('ASK_CONFIRMATION', payload)
  },
  closeAskConfirmation: (context:any) => {
    context.commit('SET_VISIBILITY', {modal:'confirmModal', newState:false})
  },
  setVisibility: (context:any,payload:{modal:any, newState:boolean}) => {
    context.commit('SET_VISIBILITY', payload)
  },
  setClusterSelected: (context:any, newCluster:APICluster | null) => {
    context.commit('SET_CLUSTER_SELECTED', newCluster)
  },
  setNodePools: (context:any, nodePools:NodePool[]) => {
    context.commit('SET_NODE_POOLS', nodePools)
  },
  hideAll: (context:any) => {
    context.commit('HIDE_ALL')
  },
}
export default {
  state,
  getters,
  mutations,
  actions
}